const pressBanner = () => {
    const mainPattern = document.querySelectorAll('.gg-banner-presses');
    mainPattern.forEach((module) => {
        module.querySelectorAll('article.gravity-block-dynamic-boxes__box a').forEach(a => {
            const externalLink = a.querySelector('.gravity-block-dynamic-boxes__presses-external-link');
            if (externalLink) {
                a.target = '_blank';
            }
        });
    });
};

pressBanner();